"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.casePath = void 0;
const rambda_1 = require("rambda");
const casePath = (path) => (onTrue, onFalse) => (o) => !!(0, rambda_1.path)(path, o) ? onTrue : onFalse;
exports.casePath = casePath;
